//keys depends on back-end settings
import { REGULATOR } from './regulators';

//keys depends on back-end settings
export const HUB = {
  FUSION_MARKETS: 'FUSION_MARKETS',
  FUSION_MARKETS_X: 'FUSION_MARKETS_X',
  FUSION_MARKETS_EU: 'FUSION_MARKETS_EU', //temporary solution, will be removed when FDS-3902 will be released
  FUSION_MARKETS_CY: 'FUSION_MARKETS_EU', //TODO CYSEC: need to update it when BE will be updated
};

/**
 * REGULATORS. List of supported regulators. The order is important, in some cases gets 'default' regulator as 1st item from the list
 */
export const HUB_INFO = {
  FUSION_MARKETS: {
    KEY: HUB.FUSION_MARKETS,
    LABEL: 'Fusion Markets AU',
    CODE: 'au',
    REGULATORS: [REGULATOR.ASIC],
  },
  FUSION_MARKETS_X: {
    KEY: HUB.FUSION_MARKETS_X,
    LABEL: 'Fusion Markets EN',
    CODE: 'en',
    REGULATORS: [REGULATOR.VFSC, REGULATOR.SEY],
  },
  FUSION_MARKETS_EU: {
    KEY: HUB.FUSION_MARKETS_EU,
    LABEL: 'Fusion Markets EU',
    CODE: 'eu',
    REGULATORS: [REGULATOR.CYSEC],
  },
  FUSION_MARKETS_CY: {
    KEY: HUB.FUSION_MARKETS_CY,
    LABEL: 'Fusion Markets EU',
    CODE: 'eu', //TODO FDS-3902 CYSEC: need to change in DB on cy
    REGULATORS: [REGULATOR.CYSEC],
  },
};
